import type { QueryObserverOptions } from '@tanstack/react-query'

import {
    type GetRecruitment400,
    type GetRecruitmentQueryKey,
    type GetRecruitmentQueryParams,
    type GetRecruitmentQueryResponse,
    useGetRecruitment,
} from '@/shared/api'
import type { ResponseErrorConfig } from '@/shared/api/axios-client'

interface UseRecruitmentFetchProps {
    params: GetRecruitmentQueryParams
    query?: Partial<
        QueryObserverOptions<
            GetRecruitmentQueryResponse,
            ResponseErrorConfig<GetRecruitment400>,
            GetRecruitmentQueryResponse,
            GetRecruitmentQueryResponse,
            GetRecruitmentQueryKey
        >
    >
}

export const useRecruitmentFetch = ({ params, query }: UseRecruitmentFetchProps) => {
    const { data, isLoading, isPlaceholderData, error } = useGetRecruitment(params, {
        query,
    })

    return {
        recruitment: data?.recruitment ?? [],
        meta: data?.meta ?? {},
        total: data?.meta?.total ?? 0,
        isEmpty: !data?.recruitment?.length,
        isLoading,
        isPlaceholderData,
        error,
    }
}
